import React, { Component } from "react";
import InferenceForecaster from "../../Context/Components/InferenceForecaster";
import ButtonRuleRep from "../ButtonRuleRep";
import DeductionButtonMaker from "./../Deducer Tools/DeductionButtonMaker";

// fonction appelée par Deducer, qui envoie des props sur un exercice de logique (qui ont pour origine le fichier Exercices.json) ainsi que valueInference
class ShowInformationsExercise extends Component {
  // on crée un ensemble html qui va organiser l'affichage des prémisses, qu'il y en ait 1, 2, 150, 0

  useOfAddInference = (infItself, infNumCom) => {
    // cette méthode crée une inférence à partir de données envoyées par Deducer (au moment d'un clic sur la prémisse). D'abord on crée un objet contenant toutes les bonnes données.
    const inference = {
      itself: infItself,
      numberCommentary: infNumCom,
      commentary: "rep",
    };
    // Puis on envoie utilise cet objet comme argument de la fonction contextuelle addInference, qui provient d'InferenceProvider
    this.props.valueInference.setJournal(
      "Répétition de la prémisse " + inference.itself,
      "rule-journal"
    );
    this.props.valueInference.addInference(inference);
  };

  makeMiniPopupOfSIE = (title, content) => {
    return (
      <div className="titlePremissesOrConclusion">
        {title}
        <span className="miniPopup-button titlePremissesOrConclusion">
          <i className={`icon fas fa-question-circle`} />
          <div className="miniPopup">
            {content && <ul className="miniPopup-content">{content}</ul>}
          </div>
        </span>
      </div>
    );
  };

  useOfForecastInference = (infItself, infNumCom) => {
    //  anticipation de la prochaine inférence
    InferenceForecaster(
      [infItself], // le contenu de l'inférence répétée
      infNumCom, // le numéro de l'inférence répétée (une lettre dans ce cas-là)
      "rep", // le nom de la règle, toujours "rep" dans ce cas
      this.props.valueInference
    );
  };

  // le render retourne à déducer l'ensemble des prémisses + la conclusion en organisant l'affichage du tout
  render() {
    // si c'est le sandbox qui a été envoyé, on ne retourne pas d'infos d'exos
    if (this.props.exerciseSent.doable === "sandbox") {
      return null;
    }

    let setOfPremisses = [];
    let numberOfPremisses = 9; // cette variable permet de connaître le numéro de la prémisse. Elle utilise une fonction, que je ne comprends pas, pour traduire un nombre en lettre.
    let textCanItBeDone = "";
    if (this.props.exerciseSent.doable === false) {
      textCanItBeDone = (
        <p
          style={{
            fontStyle: "normal",
            fontSize: "12px",
            color: "grey",
            marginTop: "5px",
          }}
        >
          La création de cet exercice n'est pas terminée, il n'a donc
          probablement pas de solution.
        </p>
      );
    }
    if (this.props.exerciseSent.premisses.length === 0) {
      // CSS pour le cas où y'a pas de prémisses
      setOfPremisses = (
        <div
          style={{
            fontStyle: "normal",
            fontSize: "11px",
            width: "120px",
            color: "grey",
          }}
        >
          (Cet exercice n'a pas de prémisses, c'est un théorème.)
        </div>
      );
    } else {
      for (let i = 0; i < this.props.exerciseSent.premisses.length; i++) {
        numberOfPremisses++;
        const newLetter = numberOfPremisses.toString(36).toLowerCase();
        setOfPremisses.push(
          <ButtonRuleRep
            key={i}
            className={"premisse selectable"}
            NumberButton={newLetter}
            NameButton={this.props.exerciseSent.premisses[i]}
            useOfAddInferenceSent={() =>
              this.useOfAddInference(
                this.props.exerciseSent.premisses[i],
                newLetter
              )
            }
            useOfForecastInferenceSent={() =>
              this.useOfForecastInference(
                this.props.exerciseSent.premisses[i],
                newLetter
              )
            }
            resetForecastInferenceSent={() =>
              this.useOfForecastInference("reset")
            }
          />
        );
      }
    }
    return (
      <div id="deducer-infos-exercise">
        <p className={"exercise-title "}>
          {this.props.exerciseSent.title}
          {/* {exerciseComment} */}
        </p>
        {textCanItBeDone}
        <ul className="setPremissesAndConclusion">
          <ul className="setPremissesOrConclusion">
            {this.makeMiniPopupOfSIE(
              "Prémisses",
              "Une prémisse est une inférence que vous admettez comme vraie, en dehors même de la déduction. Vous pouvez donc la répéter à tout moment d'une déduction."
            )}
            {setOfPremisses}
          </ul>
          <ul className="setPremissesOrConclusion">
            {this.makeMiniPopupOfSIE(
              "Conclusion",
              "La conclusion est l'inférence à laquelle vous devez arriver pour réussir un exercice."
            )}
            <div id="conclusion">{this.props.exerciseSent.conclusion}</div>
          </ul>
          <ul className="setPremissesOrConclusion" id="optimal-line-number">
            {this.makeMiniPopupOfSIE(
              "Nombre optimal",
              "Si vous le souhaitez, vous pouvez tenter d'optimiser votre nombre d'inférences pour en faire le moins possible pour un exercice donné."
            )}
            <p>d'inférences : {this.props.optimalLineNumber}</p>
          </ul>
        </ul>
        <ul
          className={
            "options-panel colorInterface" +
            this.props.valueInference.booleansOptionsAboutInferences
              .actualInterfaceColor
          }
          id="DeductionButtons"
        >
          {/* niveau de couleur d'interface 5 */}
          <DeductionButtonMaker valueInference={this.props.valueInference} />
        </ul>
      </div>
    );
  }
}
export default ShowInformationsExercise;



// WEBPACK FOOTER //
// ./src/components/Calcul Tools/Deducer Tools/ShowInformationsExercise.js